import { render } from "./FormPopupView.vue?vue&type=template&id=197c780e&scoped=true"
import script from "./FormPopupView.vue?vue&type=script&lang=js"
export * from "./FormPopupView.vue?vue&type=script&lang=js"

import "./FormPopupView.vue?vue&type=style&index=0&id=197c780e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197c780e"]])

export default __exports__